import type { IconProps } from "@/components/Icons/index";

/** From `public/assets/images/figma/sidebar-dashboard.svg` — `viewBox="0 0 20 20"`. */
export const SidebarDashboardIcon: React.FC<IconProps> = (props) => (
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.8997 16.5859C16.4922 15.2123 17.5 13.182 17.5 10.9134C17.5 6.76691 14.1433 3.41016 9.99675 3.41016C5.85757 3.41016 2.5 6.76691 2.5 10.9134C2.5 13.182 3.50865 15.2123 5.10108 16.5859"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.1968 7.72656L11.1625 9.76087M11.6362 10.9155C11.6362 11.8228 10.9008 12.5574 9.99348 12.5574C9.08698 12.5574 8.35156 11.8228 8.35156 10.9155C8.35156 10.0082 9.08698 9.27279 9.99348 9.27279C10.9008 9.27279 11.6362 10.0082 11.6362 10.9155Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
